export default [
  {
    path: '/transacoes-new',
    name: 'LancarValores',
    component: () => import('./LancarValores'),
    meta: {
      routerBack: '/transacoes',
      sidebar: false,
      icon: 'keyboard_backspace',
      title: 'Lançar valores',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Transacoes/LancarValores/LancarValoresRouter.js